export default __webpack_public_path__ + "static/media/policies.2783ae48.svg";